/***
 Hay que crear un Observer(wathcher) para detectar cuando se carga el contenido de la pagina
 ya que existe un componente tipo cliente que afecta la carga del contenido para pintarlo a posterior
 y disparar
 **/
// Callback que se ejecutará cuando se detecten mutaciones
const callbackWatcher = (mutationsList, observer, selector, functionCallback) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Verifica si el elemento con el ID específico ha sido añadido
      const formExist = document.querySelector(selector)
      if (formExist) {
        //CODE
        observer.disconnect()
        return functionCallback()
      }
    }
  }
}

export const watcherDOM = (selector, callbackFunction) => {
  // Selecciona el nodo que deseas observar
  const targetNode = document.body
  // Opciones de configuración para el observer
  const config = { childList: true, subtree: true }
  // Crea una instancia de MutationObserver con la función de callback
  const observer = new MutationObserver((mutationsList, observer) =>
    callbackWatcher(mutationsList, observer, selector, callbackFunction),
  )
  // Comienza a observar el nodo objetivo con las opciones de configuración especificadas
  observer.observe(targetNode, config)
}

if (typeof window !== 'undefined' && !window.watcherDOM) {
  window.watcherDOM = watcherDOM
}
